<template>
    <b-tooltip :label="account.provider + ' ' + account.created_at">
        <span class="tag is-family-secondary" v-if="account.provider === 'apple'">
            <b-icon icon="apple" size="is-small"></b-icon>
        </span>

        <span class="tag is-primary" v-if="account.provider === 'facebook'">
            <b-icon icon="facebook" size="is-small"></b-icon>
        </span>

        <span class="tag is-info" v-if="account.provider === 'twitter'">
            <b-icon icon="twitter" size="is-small"></b-icon>
        </span>

        <span class="tag is-warning" v-if="account.provider === 'google'">
            <b-icon icon="google" size="is-small"></b-icon>
        </span>
    </b-tooltip>
</template>

<script>
    export default {
        props: {
            account: {
                type: Object,
                required: true,
            }
        }
    };
</script>
